
import React from 'react'
import { applyMiddleware, createStore, combineReducers } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'

import * as reducers from '../reducers'

import App from '../components/App'

const createStoreWithMiddlewares = applyMiddleware(thunk)(createStore)
const reducer = combineReducers(reducers)


export default initialState => {
  const store = createStoreWithMiddlewares(reducer, initialState)

  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}
